export default "__VITE_ASSET__$lI_VDTw__"